(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(11935);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PageSection; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(55027);
;// CONCATENATED MODULE: ./src/components/PageSection/svg/CurvedSvg.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 20px;\n  clip-path: url(",
        ");\n\n  background: ",
        ";\n\n  & svg {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var sharedStyles = function(theme, clipPath, clipFill) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), clipPath, function() {
        if (theme.isDark) {
            return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.dark) || (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
        }
        return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
    });
};
var ConcaveContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-89c7dd53-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConcaveCurve" ? "translate(0, -13px)" : "translate(0, 1px)";
});
var ConvexContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-89c7dd53-1"
})(_templateObject2(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConvexCurve" ? "translate(0, -13px)" : "translate(0, -1px)";
});
var ConvexTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#topConvexCurve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "topConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C 0.75 0, .25 0, 0 1 Z"
                    })
                })
            })
        })
    });
};
var ConvexBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConvexCurve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "bottomConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#topConcaveCurve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "topConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConcaveCurve",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "bottomConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C .75 0.1, .25 0.1, 0 1 Z"
                    })
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/PageSection/CurvedDivider.tsx

function CurvedDivider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  z-index: ",
        ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n"
    ]);
    CurvedDivider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurvedDivider_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    CurvedDivider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9b87420f-0"
})(CurvedDivider_templateObject(), function(param) {
    var theme = param.theme, dividerFill = param.dividerFill;
    if (theme.isDark) {
        return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || "none";
    }
    return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || "none";
}, function(param) {
    var index = param.index;
    return index;
});
var ComponentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9b87420f-1"
})(CurvedDivider_templateObject1(), function(param) {
    var index = param.index;
    return index + 1;
});
var CurvedDivider = function(param) {
    var index = param.index, dividerPosition = param.dividerPosition, dividerComponent = param.dividerComponent, concave = param.concave, clipFill = param.clipFill, dividerFill = param.dividerFill;
    var showConvexTop = dividerPosition === "top" && !concave;
    var showConvexBottom = dividerPosition === "bottom" && !concave;
    var showConcaveTop = dividerPosition === "top" && concave;
    var showConcaveBottom = dividerPosition === "bottom" && concave;
    var getConcaveDivider = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                showConcaveTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConcaveTop, {
                    clipFill: clipFill
                }),
                showConcaveBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConcaveBottom, {
                    clipFill: clipFill
                })
            ]
        });
    };
    var getConvexDivider = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                showConvexTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvexTop, {
                    clipFill: clipFill
                }),
                showConvexBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvexBottom, {
                    clipFill: clipFill
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        index: index,
        dividerFill: dividerFill,
        children: [
            dividerComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper, {
                index: index,
                children: dividerComponent
            }),
            getConcaveDivider(),
            getConvexDivider()
        ]
    });
};
/* harmony default export */ var PageSection_CurvedDivider = (CurvedDivider);

;// CONCATENATED MODULE: ./src/components/PageSection/index.tsx




function PageSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  align-items: center;\n  z-index: ",
        ";\n  padding: ",
        ";\n"
    ]);
    PageSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: auto;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  ",
        " {\n    padding-top: 32px;\n    padding-bottom: 32px;\n  }\n\n  ",
        " {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n"
    ]);
    PageSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var BackgroundColor = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-8a71fbea-0"
})(PageSection_templateObject(), function(param) {
    var index = param.index;
    return index - 1;
}, function(param) {
    var getPadding = param.getPadding;
    return getPadding();
});
var ChildrenWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-8a71fbea-1"
})(PageSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PageSection = function(_param) {
    var children = _param.children, background = _param.background, svgFill = _param.svgFill, _index = _param.index, index = _index === void 0 ? 1 : _index, dividerComponent = _param.dividerComponent, _dividerPosition = _param.dividerPosition, dividerPosition = _dividerPosition === void 0 ? "bottom" : _dividerPosition, _hasCurvedDivider = _param.hasCurvedDivider, hasCurvedDivider = _hasCurvedDivider === void 0 ? true : _hasCurvedDivider, _concaveDivider = _param.concaveDivider, concaveDivider = _concaveDivider === void 0 ? false : _concaveDivider, clipFill = _param.clipFill, dividerFill = _param.dividerFill, containerProps = _param.containerProps, innerProps = _param.innerProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "background",
        "svgFill",
        "index",
        "dividerComponent",
        "dividerPosition",
        "hasCurvedDivider",
        "concaveDivider",
        "clipFill",
        "dividerFill",
        "containerProps",
        "innerProps"
    ]);
    var getPadding = function() {
        // No curved divider
        if (!hasCurvedDivider) {
            return "48px 0";
        }
        // Bottom curved divider
        // Less bottom padding, as the divider is present there
        if (dividerPosition === "bottom") {
            return "48px 0 14px";
        }
        // Top curved divider
        // Less top padding, as the divider is present there
        if (dividerPosition === "top") {
            return "14px 0 48px";
        }
        return "48px 0";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, containerProps), {
        children: [
            hasCurvedDivider && dividerPosition === "top" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundColor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                background: background,
                index: index,
                getPadding: getPadding
            }, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, innerProps), {
                    children: children
                }))
            })),
            hasCurvedDivider && dividerPosition === "bottom" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            })
        ]
    }));
};
/* harmony default export */ var components_PageSection = (PageSection);


/***/ }),

/***/ 11935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/components/PageSection/index.tsx + 2 modules
var PageSection = __webpack_require__(67512);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(83559);
// EXTERNAL MODULE: ./src/state/satt/hooks.ts
var hooks = __webpack_require__(12049);
// EXTERNAL MODULE: ./packages/uikit/src/components/Footer/styles.tsx + 5 modules
var styles = __webpack_require__(6845);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useMatchBreakpoints.ts + 1 modules
var useMatchBreakpoints = __webpack_require__(70589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/views/Pools/helpers.tsx
var helpers = __webpack_require__(53136);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var pools_hooks = __webpack_require__(23637);
// EXTERNAL MODULE: ./src/utils/latinise.ts
var latinise = __webpack_require__(11438);
// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/index.tsx + 5 modules
var PoolCard = __webpack_require__(37325);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(40508);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber_js_bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/utils/apr.ts + 1 modules
var apr = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@moonbiz/sdk/dist/sdk.esm.js + 58 modules
var sdk_esm = __webpack_require__(64922);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var farms_hooks = __webpack_require__(17166);
// EXTERNAL MODULE: ./src/views/Pools/components/CakeVaultCard/index.tsx + 9 modules
var CakeVaultCard = __webpack_require__(3895);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Community.tsx
var Community = __webpack_require__(11051);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Swap.tsx
var Swap = __webpack_require__(96135);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Chart.tsx
var Chart = __webpack_require__(85462);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var immutable_dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./src/views/Swap/index.tsx + 32 modules
var views_Swap = __webpack_require__(11386);
;// CONCATENATED MODULE: ./src/views/Home/components/MetricsSection/index.tsx








var Stats = function() {
    var t = (0,Localization/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.Z)().theme;
    var ref = (0,immutable_dist/* default */.Z)("tvl"), tvl = ref.data;
    var ref1 = (0,immutable_dist/* default */.Z)("totalTx30Days"), txCount = ref1.data;
    var ref2 = (0,immutable_dist/* default */.Z)("addressCount30Days"), addressCount = ref2.data;
    var trades = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(txCount);
    var users = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(addressCount);
    var tvlString = tvl ? (0,formatBalance/* formatLocalisedCompactNumber */.uI)(tvl) : "-";
    var tvlText = t("And those users are now entrusting the platform with over $%tvl% in funds.", {
        tvl: tvlString
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)(tvlText.split(tvlString), 2), entrusting = ref3[0], inFunds = ref3[1];
    var UsersCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Community/* default */.Z, {
            color: "primary",
            width: "36px"
        })
    };
    var TradesCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Swap/* default */.Z, {
            color: "secondary",
            width: "36px"
        })
    };
    var StakedCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
            color: "warning",
            width: "36px"
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            flexDirection: [
                "column",
                null,
                null,
                "row"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Swap/* default */.Z, {})
        })
    });
};
/* harmony default export */ var MetricsSection = (Stats);

// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(53629);
;// CONCATENATED MODULE: ./src/views/Home/components/Hero.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: radial-gradient(120.83% 120.83% at 50% -7.29%, #fc3d21 13.54%, #931300 100%);\n  color: #ffffff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






// const flyingAnim = () => keyframes`
//   from {
//     transform: translate(0,  0px);
//   }
//   50% {
//     transform: translate(-5px, -5px);
//   }
//   to {
//     transform: translate(0, 0px);
//   }
// `
// const fading = () => keyframes`
//   from {
//     opacity: 0.9;
//   }
//   50% {
//     opacity: 0.1;
//   }
//   to {
//     opacity: 0.9;
//   }
// `
// const BgWrapper = styled.div`
//   z-index: -1;
//   overflow: hidden;
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   bottom: 0px;
//   left: 0px;
// `
// const InnerWrapper = styled.div`
//   position: absolute;
//   width: 100%;
//   bottom: -3px;
// `
var ButtonSwap = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-b831930d-0"
})(_templateObject());
// const BunnyWrapper = styled.div`
//  width: 100%;
//  animation: ${flyingAnim} 3.5s ease-in-out infinite;
//  will-change: transform;
//  > span {
//    overflow: visible !important; //make sure the next-image pre-build blur image not be cropped
//  }
// `
// const StarsWrapper = styled.div`
//  position: absolute;
//  top: 0;
//  left: 0;
//  & :nth-child(2) {
//    animation: ${fading} 2s ease-in-out infinite;
//    animation-delay: 1s;
//  }
//  & :nth-child(3) {
//    animation: ${fading} 5s ease-in-out infinite;
//    animation-delay: 0.66s;
//  }
//  & :nth-child(4) {
//    animation: ${fading} 2.5s ease-in-out infinite;
//    animation-delay: 0.33s;
//  }
// `
// const starsImage: CompositeImageProps = {
//   path: '/images/home/lunar-bunny/',
// }
var Hero = function() {
    var t = (0,Localization/* useTranslation */.$G)().t;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            position: "relative",
            flexDirection: [
                "column-reverse",
                null,
                null,
                "row"
            ],
            alignItems: [
                "flex-end",
                null,
                null,
                "center"
            ],
            justifyContent: "center",
            mt: [
                account ? "280px" : "50px",
                null,
                0
            ],
            id: "homepage-hero",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flex: "1",
                flexDirection: "column",
                alignItems: "center",
                style: {
                    textAlign: "center",
                    padding: "0 6%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "xxl",
                        color: "#E9E9E9",
                        mb: "24px",
                        fontFamily: "Open Sans",
                        fontStyle: "normal",
                        fontSize: "80px!important",
                        fontWeight: "800",
                        letterSpacing: "0.01em",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            children: [
                                " ",
                                t("Welcome To the Moon!")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "xxl",
                        color: "#E9E9E9",
                        mb: "24px",
                        fontFamily: "Open Sans",
                        fontStyle: "normal",
                        fontSize: "36px !important",
                        fontWeight: "700",
                        letterSpacing: "0.03em",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            children: [
                                " ",
                                t("SWAP, FARM & SPEND RP1")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        mb: "24px",
                        color: "#E9E9E9",
                        fontFamily: "Work Sans",
                        fontStyle: "normal",
                        fontSize: "18px !important",
                        fontWeight: "700",
                        children: [
                            t("The Rocket Propelant One ak RP1 is the fuel for your trip to the moon."),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "#E9E9E9",
                                fontFamily: "Work Sans",
                                fontStyle: "normal",
                                fontSize: "18px !important",
                                fontWeight: "700",
                                textAlign: "center",
                                children: t("Prepare yourself farm RP1 now!")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                            to: "/swap",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSwap, {
                                children: t("Swap now")
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_Hero = (Hero);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 



function Home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n  margin: 0;\n  width: 100%;\n  background-image: url('images/home/MOON10C1.png');\n\n  background-position: bottom center;\n  background-repeat: no-repeat;\n  background-size: cover;\n\n  ",
        " {\n    padding-top: 48px;\n  }\n"
    ]);
    Home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n  font-family: 'Work Sans';\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-size: x-large;\n  padding: 22px 15px;\n  line-height: 100%;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  letter-spacing: 0.03em;\n  color: #fc3d21;\n  background-color: unset;\n  border-radius: 0;\n  width: 282px;\n  border-bottom: 5px solid #fc3d21;\n  box-shadow: none;\n  max-width: 30vw;\n  ",
        " {\n    max-width: 10vw;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-size: x-large;\n  padding: 22px 15px;\n  line-height: 100%;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  letter-spacing: 0.03em;\n  color: #ceccda;\n  background-color: unset;\n  border-radius: 0;\n  border-bottom: 1px solid #ceccda;\n  box-shadow: none;\n  max-width: 30vw;\n  ",
        " {\n    max-width: 10vw;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  //width: 282px;\n  font-size: x-large;\n  padding: 22px 15px;\n  line-height: 100%;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  letter-spacing: 0.03em;\n  color: #c9dcfb;\n  background-color: unset;\n  border-radius: 0;\n  border-bottom: 5px solid #c9dcfb;\n  box-shadow: none;\n  max-width: 30vw;\n  ",
        " {\n    max-width: 10vw;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-size: x-large;\n  padding: 22px 15px;\n  line-height: 100%;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  letter-spacing: 0.03em;\n  color: #9f9dad;\n  background-color: unset;\n  border-radius: 0;\n  border-bottom: 1px solid #9f9dad;\n  box-shadow: none;\n  max-width: 30vw;\n  ",
        " {\n    max-width: 10vw;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Open Sans';\n  font-style: normal;\n  align-items: center;\n  text-align: center;\n  font-weight: 700;\n  font-size: 20px;\nline-height: 20px;\n  line-height: 100%;\n  position: absolute;\n  top: 170px;\n  align-items: flex-end;\n  text-align: center;\n  letter-spacing: 0.02em;\n  ",
        " {\n    font-weight: 700;\n    font-size: 28.43px;\n    line-height: 100%;\n    position: absolute;\n    align-items: flex-end;\n    text-align: center;\n    letter-spacing: 0.02em;\n  };\n}\n  \n  \n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Open Sans';\n  font-style: normal;\n  align-items: center;\n  text-align: center;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 19px;\n  position: absolute;\n  top: 205px;\n  align-items: flex-end;\n  text-align: center;\n  letter-spacing: 0.02em;\n  color: #7d9cd1;\n  ",
        " {\n    font-weight: 700;\n    font-size: 28.43px;\n    line-height: 100%;\n    position: absolute;\n\n    align-items: flex-end;\n    text-align: center;\n    letter-spacing: 0.02em;\n  };\n}\n  \n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nfont-weight: 700;\nfont-size: 20px;\nline-height: 20px;\nposition: absolute;\ntop: 170px;\nalign-items: flex-end;\ntext-align: center;\nletter-spacing: 0.02em;\n  font-family: 'Open Sans';\n  font-style: normal;\n  align-items: center;\n  text-align: center;\n \n  ",
        " {\n    font-weight: 700;\n    font-size: 28.43px;\n    line-height: 100%;\n    position: absolute;\n    top: 170px;\n    align-items: flex-end;\n    text-align: center;\n    letter-spacing: 0.02em;\n  };\n}\n  \n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Open Sans';\n  font-style: normal;\n  align-items: center;\n  text-align: center;\n  font-weight: 700;\n  font-size: 28.43px;\n  line-height: 100%;\n  position: absolute;\n  top: 198px;\n  align-items: flex-end;\n  text-align: center;\n  letter-spacing: 0.02em;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}











// import WinSection from './components/WinSection'

















var StyledHeroSection = (0,styled_components_browser_esm/* default */.ZP)(PageSection/* default */.Z).withConfig({
    componentId: "sc-70fb397c-0"
})(Home_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
});
var CardLayout = (0,styled_components_browser_esm/* default */.ZP)(Layout_Flex/* default */.Z).withConfig({
    componentId: "sc-70fb397c-1"
})(_templateObject1());
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var ActiveButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-70fb397c-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var InactiveButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-70fb397c-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var ActiveDarkButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-70fb397c-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var InactiveDarkButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-70fb397c-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var FarmText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70fb397c-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var FarmText2 = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70fb397c-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var PoolText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70fb397c-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var PoolText2 = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70fb397c-9"
})(_templateObject9());
var NUMBER_OF_POOLS_VISIBLE = 3;
var NUMBER_OF_FARMS_VISIBLE = 3;
var Home = function() {
    var theme = (0,useTheme/* default */.Z)().theme;
    var ref = (0,react.useState)("pools"), type = ref[0], setType = ref[1];
    var ref1 = (0,react.useState)(NUMBER_OF_POOLS_VISIBLE), numberOfPoolsVisible = ref1[0];
    var ref2 = (0,react.useState)(""), searchQuery = ref2[0];
    var pathname = (0,router.useRouter)().pathname;
    var sortPools = function(account, sortOption, pools, poolsToSort) {
        switch(sortOption){
            case "apr":
                // Ternary is needed to prevent pools without APR (like MIX) getting top spot
                return orderBy_default()(poolsToSort, function(pool) {
                    return pool.apr ? pool.apr : 0;
                }, "desc");
            case "earned":
                return orderBy_default()(poolsToSort, function(pool) {
                    if (!pool.userData || !pool.earningTokenPrice) {
                        return 0;
                    }
                    if (pool.vaultKey) {
                        var vault = pool;
                        if (!vault.userData || !vault.userData.userShares) {
                            return 0;
                        }
                        return (0,helpers/* getCakeVaultEarnings */.UN)(account, vault.userData.cakeAtLastUserAction, vault.userData.userShares, vault.pricePerFullShare, vault.earningTokenPrice, vault.userData.currentOverdueFee.plus(vault.userData.currentPerformanceFee)).autoUsdToDisplay;
                    }
                    return pool.userData.pendingReward.times(pool.earningTokenPrice).toNumber();
                }, "desc");
            case "totalStaked":
                {
                    return orderBy_default()(poolsToSort, function(pool) {
                        var ref;
                        var totalStaked = Number.NaN;
                        if (pool.vaultKey) {
                            var vault = pool;
                            if (pool.stakingTokenPrice && vault.totalCakeInVault.isFinite()) {
                                totalStaked = +(0,lib_esm/* formatUnits */.bM)(bignumber/* BigNumber.from */.O$.from(vault.totalCakeInVault.toString()), pool.stakingToken.decimals) * pool.stakingTokenPrice.toNumber();
                            }
                        } else if (((ref = pool.totalStaked) === null || ref === void 0 ? void 0 : ref.isFinite()) && pool.stakingTokenPrice) {
                            totalStaked = +(0,lib_esm/* formatUnits */.bM)(bignumber/* BigNumber.from */.O$.from(pool.totalStaked.toString()), pool.stakingToken.decimals) * pool.stakingTokenPrice.toNumber();
                        }
                        return Number.isFinite(totalStaked) ? totalStaked : 0;
                    }, "desc");
                }
            case "latest":
                return orderBy_default()(poolsToSort, function(pool) {
                    return Number(pool.sousId);
                }, "desc");
            default:
                return poolsToSort;
        }
    };
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var sattAddress = (0,hooks/* useSattWallet */.M)().sattAddress;
    var address = account || sattAddress || undefined;
    var ref3 = (0,react.useState)("hot"), sortOption = ref3[0];
    var pools = (0,pools_hooks/* usePoolsWithVault */.f6)().pools;
    var isArchived = pathname.includes("archived");
    var isInactive = pathname.includes("history");
    var isActive = !isInactive && !isArchived;
    var cakePrice = (0,bignumber_js_bignumber/* default */.Z)(localStorage.getItem("price"));
    var ref4 = (0,react.useState)(""), query = ref4[0];
    (0,pools_hooks/* usePoolsPageFetch */.l7)();
    (0,farms_hooks/* usePollFarmsWithUserData */.Cs)();
    var pools2 = (0,es/* useSelector */.v9)(function(state) {
        return state.pools;
    });
    var chosenPools = pools2.data;
    var ref5 = (0,react.useState)(NUMBER_OF_FARMS_VISIBLE), numberOfFarmsVisible = ref5[0];
    chosenPools = (0,react.useMemo)(function() {
        var sortedPools = sortPools(address, sortOption, pools, chosenPools).slice(0, numberOfPoolsVisible);
        if (searchQuery) {
            var lowercaseQuery = (0,latinise/* latinise */.b)(searchQuery.toLowerCase());
            return sortedPools.filter(function(pool) {
                return (0,latinise/* latinise */.b)(pool.earningToken.symbol.toLowerCase()).includes(lowercaseQuery);
            });
        }
        return sortedPools;
    }, [
        address,
        sortOption,
        pools,
        chosenPools,
        numberOfPoolsVisible,
        searchQuery
    ]);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserPoolStakedOnly */.tw)(), 1), stakedOnly = ref6[0];
    var ref7 = (0,farms_hooks/* useFarms */.E2)(), farmsLP = ref7.data, poolLength = ref7.poolLength, regularCakePerBlock = ref7.regularCakePerBlock;
    var archivedFarms = farmsLP;
    var stakedArchivedFarms = archivedFarms.filter(function(farm) {
        return farm.userData && new bignumber_js_bignumber/* default */.Z(farm.userData.stakedBalance).isGreaterThan(0);
    });
    var inactiveFarms = farmsLP.filter(function(farm) {
        return farm.pid !== 0 && farm.pid !== 1 && farm.pid !== 2 && farm.multiplier === "0X";
    });
    var stakedInactiveFarms = inactiveFarms.filter(function(farm) {
        return farm.userData && new bignumber_js_bignumber/* default */.Z(farm.userData.stakedBalance).isGreaterThan(0);
    });
    var activeFarms = farmsLP.filter(function(farm) {
        return farm.pid !== 0 && farm.pid !== 1 && farm.pid !== 2 && farm.multiplier !== "0X" && (!poolLength || poolLength > farm.pid);
    });
    var stakedOnlyFarms = activeFarms.filter(function(farm) {
        return farm.userData && new bignumber_js_bignumber/* default */.Z(farm.userData.stakedBalance).isGreaterThan(0);
    });
    var farmsList = (0,react.useCallback)(function(farmsToDisplay) {
        var farmsToDisplayWithAPR = farmsToDisplay.map(function(farm) {
            if (!farm.lpTotalInQuoteToken || !farm.quoteTokenPriceBusd) {
                return farm;
            }
            var totalLiquidity = new bignumber_js_bignumber/* default */.Z(farm.lpTotalInQuoteToken).times(farm.quoteTokenPriceBusd);
            var ref = isActive ? (0,apr/* getFarmApr */.yW)(new bignumber_js_bignumber/* default */.Z(farm.poolWeight), cakePrice, totalLiquidity, farm.lpAddresses[sdk_esm/* ChainId.MAINNET */.a_.MAINNET], regularCakePerBlock) : {
                cakeRewardsApr: 0,
                lpRewardsApr: 0
            }, cakeRewardsApr = ref.cakeRewardsApr, lpRewardsApr = ref.lpRewardsApr;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, farm), {
                apr: cakeRewardsApr,
                lpRewardsApr: lpRewardsApr,
                liquidity: totalLiquidity
            });
        });
        if (query) {
            var lowercaseQuery = (0,latinise/* latinise */.b)(query.toLowerCase());
            farmsToDisplayWithAPR = farmsToDisplayWithAPR.filter(function(farm) {
                return (0,latinise/* latinise */.b)(farm.lpSymbol.toLowerCase()).includes(lowercaseQuery);
            });
        }
        return farmsToDisplayWithAPR;
    }, [
        cakePrice,
        query,
        isActive,
        regularCakePerBlock
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var chosenFarmsMemoized = (0,react.useMemo)(function() {
        var chosenFarms = [];
        var sortFarms = function(farms) {
            switch(sortOption){
                case "apr":
                    return orderBy_default()(farms, function(farm) {
                        return farm.apr + farm.lpRewardsApr;
                    }, "desc");
                case "multiplier":
                    return orderBy_default()(farms, function(farm) {
                        return farm.multiplier ? Number(farm.multiplier.slice(0, -1)) : 0;
                    }, "desc");
                case "earned":
                    return orderBy_default()(farms, function(farm) {
                        return farm.userData ? Number(farm.userData.earnings) : 0;
                    }, "desc");
                case "liquidity":
                    return orderBy_default()(farms, function(farm) {
                        return Number(farm.liquidity);
                    }, "desc");
                case "latest":
                    return orderBy_default()(farms, function(farm) {
                        return Number(farm.pid);
                    }, "desc");
                default:
                    return farms;
            }
        };
        if (isActive) {
            chosenFarms = stakedOnly ? farmsList(stakedOnlyFarms) : farmsList(activeFarms);
        }
        if (isInactive) {
            chosenFarms = stakedOnly ? farmsList(stakedInactiveFarms) : farmsList(inactiveFarms);
        }
        if (isArchived) {
            chosenFarms = stakedOnly ? farmsList(stakedArchivedFarms) : farmsList(archivedFarms);
        }
        return sortFarms(chosenFarms);
    }, [
        sortOption,
        activeFarms,
        farmsList,
        inactiveFarms,
        archivedFarms,
        isActive,
        isInactive,
        isArchived,
        stakedArchivedFarms,
        stakedInactiveFarms,
        stakedOnly,
        stakedOnlyFarms,
        numberOfFarmsVisible, 
    ]);
    var ref8 = (0,useMatchBreakpoints/* default */.Z)(), isMobile = ref8.isMobile, isMd = ref8.isMd;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            marginTop: "-60px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroSection, {
                index: 2,
                hasCurvedDivider: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {}),
                    !isMd && !isMobile && !theme.isDark && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledSocialLinks */.aW, {
                        display: "flex",
                        flexDirection: "column",
                        position: "absolute",
                        top: "100px",
                        left: "0",
                        width: "3.95 vw !important",
                        background: "#FFFFFF;",
                        border: "1px solid #093174;",
                        borderRadius: "0px 15px 15px 0px;",
                        padding: "10px 0px 10px 17px"
                    }),
                    !isMd && !isMobile && theme.isDark && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledSocialLinks */.aW, {
                        display: "flex",
                        flexDirection: "column",
                        position: "absolute",
                        top: "100px",
                        left: "0",
                        width: "3.95 vw !important",
                        background: "rgba(11, 61, 145, 0.2)",
                        border: "1px solid #093174;",
                        borderRadius: "0px 15px 15px 0px;",
                        padding: "10px 0px 10px 17px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection/* default */.Z, {
                index: 2,
                hasCurvedDivider: false,
                children: [
                    !theme.isDark && (type === "pools" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        mb: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InactiveButton, {
                                onClick: function() {
                                    return setType("pools");
                                },
                                children: "Pools"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InactiveButton, {
                                onClick: function() {
                                    return setType("farms");
                                },
                                children: "Farms"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoolText, {
                                children: [
                                    " ",
                                    "Juste stake some tokens to earn.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "Hig APR, low risk."
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        mb: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InactiveButton, {
                                onClick: function() {
                                    return setType("pools");
                                },
                                children: "Pools"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InactiveButton, {
                                onClick: function() {
                                    return setType("farms");
                                },
                                children: "Farms"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmText, {
                                children: " Stake LP tokens to earn"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmText2, {
                                children: " community Auctions"
                            })
                        ]
                    })),
                    theme.isDark && (type === "pools" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        mb: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveDarkButton, {
                                onClick: function() {
                                    return setType("pools");
                                },
                                children: "Pools"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InactiveDarkButton, {
                                onClick: function() {
                                    return setType("farms");
                                },
                                children: "Farms"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoolText, {
                                children: [
                                    " ",
                                    "Juste stake some tokens to earn.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "Hig APR, low risk."
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "center",
                        mb: 6,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InactiveDarkButton, {
                                onClick: function() {
                                    return setType("pools");
                                },
                                children: "Pools"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveDarkButton, {
                                onClick: function() {
                                    return setType("farms");
                                },
                                children: "Farms"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmText, {
                                children: " Stake LP tokens to earn"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmText2, {
                                children: " community Auctions"
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: type === "pools" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardLayout, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    hidden: true
                                }),
                                chosenPools === null || chosenPools === void 0 ? void 0 : chosenPools.map(function(pool) {
                                    return pool.vaultKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard/* default */.Z, {
                                        pool: pool,
                                        showStakedOnly: stakedOnly
                                    }, pool.vaultKey) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCard/* default */.Z, {
                                        pool: pool,
                                        account: address
                                    }, pool.sousId);
                                })
                            ]
                        }) : // <CardLayout>
                        //   {chosenFarmsMemoized.map((farm) => (
                        //     <FarmCard
                        //       key={farm.pid}
                        //       farm={farm}
                        //       displayApr={getDisplayApr(farm.apr, farm.lpRewardsApr)}
                        //       cakePrice={cakePrice}
                        //       account={account || sattAddress}
                        //       removed={false}
                        //     />
                        //   ))}
                        // </CardLayout>
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var views_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
        value: {
            fallback: {
                totalTx30Days: totalTx30Days,
                addressCount30Days: addressCount30Days,
                tvl: tvl
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {})
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7857,2077,2298,2170,1314,5855,8260,3603,1039,9638,6480,8123,3439,9739,4853,1190,3197,1777,1386,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);